import * as yup from 'yup';


import {languageSelectFormConstants} from '../../I18n/LanguageSelectForm';
import {phoneFormConstants} from '../Phone/PhoneForm';
import {emailFormConstants} from '../../Email';


// ------ types
export const NAME_MAX_LENGTH = 100;
export const NAME_MIN_LENGTH = 2;

export const POSITION_LENGTH_MIN = 2;
export const POSITION_LENGTH_MAX = 200;

export const SURNAME_MAX_LENGTH = 100;
export const SURNAME_MIN_LENGTH = 2;



// ------ schema validations
export const SCHEMA_IS_NEWSLETTER_RECIPIENT = yup.bool()
    .nullable()
    .required()
    .default(false);

export const SCHEMA_IS_REACHABLE_VIA_PHONE = yup.bool()
    .nullable()
    .required()
    .default(false);

export const SCHEMA_NAME = yup.string()
    .nullable()
    .min(NAME_MIN_LENGTH)
    .max(NAME_MAX_LENGTH)
    .strictText()
    .required();

export const SCHEMA_POSITION = yup.string()
    .nullable()
    .max(POSITION_LENGTH_MAX)
    .min(POSITION_LENGTH_MIN)
    .strictText();

export const SCHEMA_SURNAME = yup.string()
    .nullable()
    .min(SURNAME_MIN_LENGTH)
    .max(SURNAME_MAX_LENGTH)
    .strictText()
    .required();


export const SCHEMA_CONTACT = yup.object()
    .shape({
        email: emailFormConstants.SCHEMA_EMAIL,
        isNewsletterRecipient: SCHEMA_IS_NEWSLETTER_RECIPIENT,
        isReachableViaPhone: SCHEMA_IS_REACHABLE_VIA_PHONE,
        locale: languageSelectFormConstants.SCHEMA_PLATFORM_LANGUAGE,
        name: SCHEMA_NAME,
        phone: phoneFormConstants.SCHEMA_PHONE_FORM,
        position: SCHEMA_POSITION.required(),
        surname: SCHEMA_SURNAME
    });
